export const tableMixin = {
  data() {
    return {
      masterTableProps: {
        fields: [
          {
            key: 'created_at',
            sortable: true,
            label: 'Date'
          },
          {
            key: 'service_type.name',
            sortable: false,
            label: 'Type'
          },
          {
            key: 'service_reference',
            sortable: true,
            label: 'Number'
          },
          {
            key: 'short_id',
            sortable: false,
            label: 'JetpayID'
          },
          {
            key: 'payer_account.name',
            sortable: true,
            label: 'Payer'
          },
          {
            key: 'transaction_amount',
            sortable: false,
            label: 'Amount'
          },
          {
            key: 'status',
            sortable: false,
            label: 'Status'
          }
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        sortDesc: true,
        totalRows: 1
      },
      masterFilterProps: {
        filterIndexes: [],
        filters: {
          payerQuery: null,
          numberFilter: null,
          startDate: '',
          endDate: ''
        }
      }
    };
  },
  computed: {
    rows: {
      get: function() {
        if (!this.filter) {
          return this.transactions.length;
        } else {
          return this.masterTableProps.totalRows;
        }
      },
      set: function(newValue) {
        this.masterTableProps.totalRows = newValue;
      } 
    },
    filter: function() {
      var self = this;
      let a = Object.values(this.masterFilterProps.filters);

      this.masterFilterProps.filterIndexes = [];
      
      a.forEach(function(value, index, array) {
        if (value) {
          self.masterFilterProps.filterIndexes.push(index);
        }
      });

      return Boolean(this.masterFilterProps.filterIndexes.length > 0) ? a : null;
    },
    payerList: function() {
      return [];
    }
  },
  methods: {
    filterTable(row, filter) {
      var buildQuery = [];

      this.masterFilterProps.filterIndexes.forEach(function(value, index, array) {
        if (value == 0) {
          buildQuery.push('row.payer_account.name.includes(filter[0])');
        }

        if (value == 1) {
          buildQuery.push('row.service_reference.includes(filter[1])');
        }

        if (value == 2) {
          buildQuery.push('new Date(row.created_at).setHours(0,0,0,0) >= new Date(filter[2])');
        }

        if (value == 3) {
          buildQuery.push('new Date(row.created_at).setHours(0,0,0,0) <= new Date(filter[3])');
        }
      });
      
      var joined = buildQuery.join(' && ');

      if (joined.length > 0 && eval(joined)) {
        return true;
      } else { 
        return false;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    clear: function() {
      for (const props in this.masterFilterProps.filters) {
        this.masterFilterProps.filters[props] = null;
      }
    },
    truncateString(string) {
      return string.substring(0, 15);
    }
  }
}